<div [class]="class" #container>
  <label>
    <input #input type="checkbox" role="checkbox" aria-label="checkbox" (change)="onChange($event)"
      (keyup)="onChange($event)" [checked]="isChecked" [attr.data-test]="testAttribute">
    <span class="checkbox" role="checkbox"></span>
  </label>
  <span role="tooltip">
    <ng-content></ng-content>
  </span>
</div>
